export enum RenewingType {
  SAME = "SAME",
  REDUCED = "REDUCED",
  FUSION = "FUSION",
}
